<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<rfc-head></rfc-head>
		<rfc-list></rfc-list>
    </v-content>
  </v-app>
</template>

<script>

	import RfcHead from './Header.vue';
	import RfcList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			RfcHead,
			RfcList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>